import { Component } from '@angular/core';

@Component({
  selector: 'app-shop-n-travel',
  imports: [],
  templateUrl: './shop-n-travel.component.html',
  styleUrl: './shop-n-travel.component.scss'
})
export class ShopNTravelComponent {

}
